import React, { useEffect, useState } from 'react';
import Loader from '../../utils/Loader';
import './CertificateModal.css';

const CertificateModal = ({ isOpen, onClose }) => {
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  // Reset loading state when modal opens
  useEffect(() => {
    if (isOpen) {
      setImageLoading(true);
      setImageError(false);
    }
  }, [isOpen]);

  // Close modal on escape key or click outside, prevent page scrolling
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
      // Also prevent scrolling on page-container (where Account page scrolls)
      const pageContainer = document.querySelector('.page-container');
      if (pageContainer) {
        pageContainer.style.overflow = 'hidden';
      }

      return () => {
        document.removeEventListener('keydown', handleEscape);
        document.body.style.overflow = '';
        // Restore scrolling on page-container - remove inline style to restore CSS default
        const restoredPageContainer = document.querySelector('.page-container');
        if (restoredPageContainer) {
          restoredPageContainer.style.removeProperty('overflow');
        }
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) {
    return null;
  }

  const handleImageLoad = () => {
    setImageLoading(false);
  };

  const handleImageError = () => {
    setImageLoading(false);
    setImageError(true);
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/assets/old/certificate.png';
    link.download = 'certificate.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleShareOnX = () => {
    const text = 'Check out my certificate from Read The Tape! pic.twitter.com/QXLTDdfynG';
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
    window.open(twitterUrl, '_blank');
  };

  return (
    <div className="certificate-modal-overlay" onClick={onClose}>
      <div className="certificate-modal" onClick={(e) => e.stopPropagation()}>
        <div className="certificate-modal-content">
          <div className="certificate-image-wrapper">
            <button className="certificate-modal-close" onClick={onClose} aria-label="Close">
              ×
            </button>
            {imageLoading && (
              <div className="certificate-loading">
                <Loader size="large" text="Loading certificate..." />
              </div>
            )}
            {imageError ? (
              <div className="certificate-error">
                <p>Failed to load certificate image</p>
              </div>
            ) : (
              <img 
                src="/assets/old/certificate.png" 
                alt="Certificate" 
                className="certificate-image"
                onLoad={handleImageLoad}
                onError={handleImageError}
                style={{ display: imageLoading ? 'none' : 'block' }}
              />
            )}
          </div>
          {!imageLoading && !imageError && (
            <div className="certificate-actions">
              <button onClick={handleDownload} className="certificate-button certificate-button-download">
                Download
              </button>
              <button onClick={handleShareOnX} className="certificate-button certificate-button-share">
                Share on X
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CertificateModal;

